<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row style="padding-top: 15px">
      <van-col span="24">
        <div class="eventListBg">
          <van-row v-for="item in systemMessages" :key="item.id">
            <div class="eventItem">
              <img
                src="../images/common/speaker.png"
                style="height: 45px; width: auto"
              />
              <div style="padding-left: 10px">
                <!-- <p class="eventTopic">{{item.name}}</p> -->
                <p class="eventDesc">
                  {{ item[lang] }}
                </p>
              </div>
            </div>
          </van-row>
        </div>
      </van-col>
    </van-row>
    <!-- ----------- tab section --------- -->
    <van-tabs v-model="activeTab" @change="onTabChange()" id="eventTabsTopic">
      <!-- -------------------------------------------- 1st tab content ------------ -->
      <van-tab :title="$t('events.myInvestments')" name="MyInvestment">
        <van-divider
          :style="{
            borderColor: '#ffffff',
            padding: '0px 10px 0px',
            margin: '0px',
          }"
        ></van-divider>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('bonus.loadFinish')"
          offset:4
          @load="onLoad"
        >
          <van-row v-for="(item, index) in investList" :key="index">
            <van-row>
              <div class="itemEvent">
                <van-row style="align-items: center; display: flex">
                  <van-col span="9">
                    <img :src="item.image" class="leftImage" />
                  </van-col>
                  <van-col span="15" style="padding-left: 10px">
                    <van-row>
                      <p class="moviesName">{{ item[lang] }}</p>
                      <van-divider
                        :style="{
                          borderColor: '#ffffff',
                          padding: '8px 0px',
                          margin: '0px',
                        }"
                      ></van-divider>
                    </van-row>
                    <van-row>
                      <van-col span="14">
                        <div style="align-items: center; display: flex">
                          <img
                            src="../images/home/arrow_left.png"
                            style="height: 15px; width: auto"
                          />
                          <p class="eventInfoItem">
                            {{ $t("events.investment") }}:
                          </p>
                        </div>
                      </van-col>
                      <van-col span="10">
                        <p class="eventInfoItem">${{ item.invest_amount }}</p>
                      </van-col>
                    </van-row>
                    <!-- <van-row style="padding: 9px 0px 0px">
                      <van-col span="14">
                        <div style="align-items: center; display: flex">
                          <img
                            src="../images/home/arrow_left.png"
                            style="height: 15px; width: auto"
                          />
                          <p class="eventInfoItem" style="word-break: break-word">
                            {{ $t("events.returnOfInvest") }}:
                          </p>
                        </div>
                      </van-col>
                      <van-col span="10">
                        <p class="eventInfoItem">${{ item.return_of_investment }}</p>
                      </van-col>
                    </van-row> -->
                    <!-- <van-row style="padding: 9px 0px 0px">
                      <van-col span="14">
                        <div style="align-items: center; display: flex">
                          <img
                            src="../images/home/arrow_left.png"
                            style="height: 15px; width: auto"
                          />
                          <p class="eventInfoItem">
                            {{ $t("events.countDown") }}:
                          </p>
                        </div>
                      </van-col>
                      <van-col span="10">
                        <p class="eventInfoItem">
                          {{ item.countdown }} {{ item.countdown > 1 ? $t("movieInvest.days") : $t("rewardRulesTabOne.day") }}
                        </p>
                      </van-col>
                    </van-row> -->
                    <van-row style="padding: 9px 0px 0px">
                      <van-col span="14">
                        <div style="align-items: center; display: flex">
                          <img
                            src="../images/home/arrow_left.png"
                            style="height: 15px; width: auto"
                          />
                          <p class="eventInfoItem">
                            {{ $t("events.expectedReturn") }}:
                          </p>
                        </div>
                      </van-col>
                      <van-col span="10">
                        <p class="eventInfoItem">
                          ${{ item.estimated_repay_amount }}
                        </p>
                      </van-col>
                    </van-row>
                    <van-row style="padding: 9px 0px 0px">
                      <van-col span="14">
                        <div style="align-items: center; display: flex">
                          <img
                            src="../images/home/arrow_left.png"
                            style="height: 15px; width: auto"
                          />
                          <p class="eventInfoItem">
                            {{ $t("events.interestRate") }}:
                          </p>
                        </div>
                      </van-col>
                      <van-col span="10">
                        <p class="eventInfoItem">
                          {{ item.rate }}%
                        </p>
                      </van-col>
                    </van-row>
                  </van-col>
                </van-row>

                <!-- <van-row>
                  <div class="sellBg" @click="callSellPopup(item)">
                    <p class="buttonText">{{ $t("events.sell") }}</p>
                  </div>
                </van-row> -->
              </div>
            </van-row>
          </van-row>
        </van-list>

        <!-- -------------- sell popup content ----------------- -->
        <van-popup
          @closed="clearSellPopupValues()"
          v-model="sellMoviePopup"
          style="width: 90%; border-radius: 15px; background: transparent"
        >
          <van-row class="PopupBg" style="padding: 10px">
            <van-row>
              <van-row>
                <van-col span="24" style="text-align: right">
                  <img
                    src="../images/bonus/closeIcon.png"
                    style="height: 18px; width: auto"
                    @click="sellMoviePopup = false"
                  />
                </van-col>
              </van-row>
              <van-row>
                <van-col span="24">
                  <img :src="selectedMovie.image" class="movieTopImage" />
                </van-col>
              </van-row>
              <van-row style="padding: 0px 5px">
                <!-- ---------sell name ------ -->
                <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic">{{ $t("events.movieName") }}</p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">{{ selectedMovie[lang] }}</p>
                  </van-col>
                </van-row>

                <!-- ---------sell go live time ------ -->
                <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic">{{ $t("events.goLiveTime") }}</p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">
                      {{ getDate(selectedMovie.release_date) }}
                    </p>
                  </van-col>
                </van-row>

                <!-- ---------sell Total  Financing ------ -->
                <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic">{{ $t("events.totalFinancing") }}</p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">${{ selectedMovie.total }}</p>
                  </van-col>
                </van-row>

                <!-- --------- sell total investment ------ -->
                <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic">
                      {{ $t("events.totalInvestemnt") }}
                    </p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">${{ selectedMovie.invest_amount }}</p>
                  </van-col>
                </van-row>
                <!-- --------- sell % investment ------ -->
                <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic" style="white-space: nowrap">
                      {{ $t("events.investemntRate") }}
                    </p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">{{ selectedMovie.share }}%</p>
                  </van-col>
                </van-row>
              </van-row>
              <!-- ---------------- Sale share ------------ -->
              <van-row class="inputBg" style="margin-top: 20px">
                <van-col span="12">
                  <p class="labelTopic">
                    {{ $t("events.saleShare") }}
                  </p></van-col
                >
                <van-col span="12"
                  ><input
                    type="number"
                    v-model="sharesSell"
                    :placeholder="$t('events.pleaseEnter')"
                    class="inputValue"
                /></van-col>
              </van-row>
              <!-- ---------------- Selling Price ------------ -->
              <van-row class="inputBg" style="margin-top: 10px">
                <van-col span="12">
                  <p class="labelTopic">
                    {{ $t("events.sellingPrice") }}
                  </p></van-col
                >
                <van-col span="12"
                  ><input
                    type="number"
                    v-model="sellPrice"
                    :placeholder="$t('events.pleaseEnter')"
                    class="inputValue"
                /></van-col>
              </van-row>
              <van-divider
                :style="{
                  borderColor: '#ffffff',
                  padding: '8px 0px 6px',
                  margin: '0px',
                }"
              >
              </van-divider>
              <!-- sell cancellation -->
              <van-row>
                <div class="btnCancelBg" @click="sellMoviePopup ^= true">
                  <p class="buttonText">{{ $t("events.cancelBtn") }}</p>
                </div>
              </van-row>
              <!-- sell button -->
              <van-row>
                <div class="btnConfirmBg" @click="sellAMovie">
                  <p class="buttonText">{{ $t("events.sellConfirm") }}</p>
                </div>
              </van-row>
            </van-row>
          </van-row>
        </van-popup>
      </van-tab>
      <!-- ------------------------------------------------- 2nd tab start ------------------ -->
      <van-tab :title="$t('events.myCollection')" name="MyCollection">
        <van-divider
          :style="{
            borderColor: '#ffffff',
            padding: '0px 10px 0px',
            margin: '0px',
          }"
        ></van-divider>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('bonus.loadFinish')"
          offset:4
          @load="onLoadFav"
        >
          <van-row v-for="item in favList" :key="item.id">
            <div class="itemEvent">
              <van-row style="align-items: center; display: flex">
                <van-col span="9">
                  <img :src="item.image" class="leftImage" />
                </van-col>
                <van-col span="15" style="padding-left: 10px">
                  <van-row>
                    <p class="moviesName">{{ item[lang] }}</p>
                    <van-divider
                      :style="{
                        borderColor: '#ffffff',
                        padding: '8px 0px',
                        margin: '0px',
                      }"
                    ></van-divider>
                  </van-row>
                  <van-row>
                    <van-col span="14">
                      <div style="align-items: center; display: flex">
                        <img
                          src="../images/home/arrow_left.png"
                          style="height: 15px; width: auto"
                        />
                        <p class="eventInfoItem">
                          {{ $t("events.investment") }}:
                        </p>
                      </div>
                    </van-col>
                    <van-col span="10">
                      <p class="eventInfoItem">${{ item.investment }}</p>
                    </van-col>
                  </van-row>
                  <van-row style="padding: 9px 0px 0px">
                    <van-col span="14">
                      <div style="align-items: center; display: flex">
                        <img
                          src="../images/home/arrow_left.png"
                          style="height: 15px; width: auto"
                        />
                        <p class="eventInfoItem">
                          {{ $t("events.openingTime") }}:
                        </p>
                      </div>
                    </van-col>
                    <van-col span="10">
                      <p class="eventInfoItem">
                        {{ getDate(item.release_date) }}
                      </p>
                    </van-col>
                  </van-row>
                  <!-- <van-row style="padding: 9px 0px 0px">
                    <van-col span="14">
                      <div style="align-items: center; display: flex">
                        <img
                          src="../images/home/arrow_left.png"
                          style="height: 15px; width: auto"
                        />
                        <p class="eventInfoItem">
                          {{ $t("events.expectedReturn") }}:
                        </p>
                      </div>
                    </van-col>
                    <van-col span="10">
                      <p class="eventInfoItem">${{ item.expected_return }}</p>
                    </van-col>
                  </van-row> -->
                </van-col>
              </van-row>
            </div>
          </van-row>
        </van-list>
      </van-tab>
      <!-- -------------------------------------------- 3rd tab content ------------ -->
      <!-- <van-tab :title="$t('events.ctocMarket')" name="C2CMarket" ref="c2cTab">
        <van-divider
          :style="{
            borderColor: '#ffffff',
            padding: '0px 10px 0px',
            margin: '0px',
          }"
        ></van-divider>

        <van-list
          v-model:loading="loading"
          :finished="finished"
          :finished-text="$t('bonus.loadFinish')"
          offset:4
          @load="onLoadC2C"
        >
          <van-row v-for="item in c2cList" :key="item.id">
            <div class="itemEvent">
              <van-row style="align-items: center; display: flex">
                <van-col span="9">
                  <img :src="item.image" class="leftImage" />
                </van-col>
                <van-col span="15" style="padding-left: 10px">
                  <van-row>
                    <p
                      class="moviesName"
                      :style="{
                        padding: '8px 0px 20px',
                      }"
                    >
                      {{ item.uid }}
                    </p>
                    <p class="moviesName">{{ item[lang] }}</p>
                    <van-divider
                      :style="{
                        borderColor: '#ffffff',
                        padding: '8px 0px',
                        margin: '0px',
                      }"
                    ></van-divider>
                  </van-row>
                  <van-row>
                    <van-col span="14">
                      <div style="align-items: center; display: flex">
                        <img
                          src="../images/home/arrow_left.png"
                          style="height: 15px; width: auto"
                        />
                        <p class="eventInfoItem">
                          {{ $t("events.investment") }}:
                        </p>
                      </div>
                    </van-col>
                    <van-col span="10">
                      <p class="eventInfoItem">$ {{ item.price }}</p>
                    </van-col>
                  </van-row>
                  <van-row style="padding: 9px 0px 0px">
                    <van-col span="14">
                      <div style="align-items: center; display: flex">
                        <img
                          src="../images/home/arrow_left.png"
                          style="height: 15px; width: auto"
                        />
                        <p class="eventInfoItem">
                          {{ $t("events.openingTime") }}:
                        </p>
                      </div>
                    </van-col>
                    <van-col span="10">
                      <p class="eventInfoItem">{{ getDate(item.time) }}</p>
                    </van-col>
                  </van-row>
                  <van-row style="padding: 9px 0px 0px">
                    <van-col span="14">
                      <div style="align-items: center; display: flex">
                        <img
                          src="../images/home/arrow_left.png"
                          style="height: 15px; width: auto"
                        />
                        <p class="eventInfoItem">
                          {{ $t("events.expectedReturn") }}:
                        </p>
                      </div>
                    </van-col>
                    <van-col span="10">
                      <p class="eventInfoItem">${{ item.expected_return }}</p>
                    </van-col>
                  </van-row>
                </van-col>
              </van-row>
              <van-row>
                <div class="sellBg" @click="callBuyPopup(item)">
                  <p class="buttonText">{{ $t("events.buy") }}</p>
                </div>
              </van-row>
            </div>
          </van-row>
        </van-list> -->
      <!-- -------------- buy popup content ----------------- -->
      <!-- <van-popup
          v-model="buyMoviePopup"
          @closed="clearValues()"
          style="width: 90%; border-radius: 15px; background: transparent"
        >
          <van-row class="PopupBg" style="padding: 10px">
            <van-row>
              <van-row>
                <van-col span="24">
                  <img :src="selectedMovie.image" class="movieTopImage" />
                </van-col>
              </van-row>
              <van-row style="padding: 0px 5px"> -->
      <!-- ---------buy name ------ -->
      <!-- <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic">{{ $t("events.movieName") }}</p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">{{ selectedMovie[lang] }}</p>
                  </van-col>
                </van-row> -->

      <!-- ---------buy go live time ------ -->
      <!-- <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic">{{ $t("events.goLiveTime") }}</p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">
                      {{ getDate(selectedMovie.release_date) }}
                    </p>
                  </van-col>
                </van-row> -->

      <!-- --------- buy Total  Financing ------ -->
      <!-- <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic">{{ $t("events.totalFinancing") }}</p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">$ {{ selectedMovie.total }}</p>
                  </van-col>
                </van-row> -->

      <!-- --------- buy total investment ------ -->
      <!-- <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic">
                      {{ $t("events.totalInvestemnt") }}
                    </p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">$ {{ selectedMovie.price }}</p>
                  </van-col>
                </van-row> -->
      <!-- --------- buy % investment ------ -->
      <!-- <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic" style="white-space: nowrap">
                      {{ $t("events.investemntRate") }}
                    </p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">{{ selectedMovie.share }} %</p>
                  </van-col>
                </van-row> -->
      <!-- --------- purchase share ------ -->
      <!-- <van-row style="padding-top: 20px">
                  <van-col span="12">
                    <p class="labelTopic" style="white-space: nowrap">
                      {{ $t("events.purchaseShare") }}
                    </p>
                  </van-col>
                  <van-col span="12" style="text-align: right">
                    <p class="labelValue">{{ purchaseShare }}%</p>
                  </van-col>
                </van-row>
              </van-row> -->

      <!-- ---------------- purchase Price ------------ -->
      <!-- <van-row class="inputBg" style="margin-top: 10px">
                <van-col span="12">
                  <p class="labelTopic">
                    {{ $t("events.purchasePrice") }}
                  </p></van-col
                >
                <van-col span="12"
                  ><input
                    type="number"
                    v-model="buyPrice"
                    :placeholder="$t('events.pleaseEnter')"
                    class="inputValue"
                    @input="calculateShare"
                /></van-col>
              </van-row>
              <van-divider
                :style="{
                  borderColor: '#ffffff',
                  padding: '8px 0px 6px',
                  margin: '0px',
                }"
              >
              </van-divider> -->
      <!-- buy cancellation -->
      <!-- <van-row>
                <div
                  class="btnCancelBg"
                  @click="cancelSell()"
                  v-if="disableBuyBtn"
                >
                  <p class="buttonText">{{ $t("events.cancelBtn") }}</p>
                </div>
              </van-row> -->
      <!-- buy button -->
      <!-- <div v-if="!disableBuyBtn">
                <van-row>
                  <div class="btnConfirmBg" @click="buyC2C()">
                    <p class="buttonText">{{ $t("events.confirmPurchase") }}</p>
                  </div>
                </van-row>
              </div>
            </van-row>
          </van-row>
        </van-popup>
      </van-tab> -->
    </van-tabs>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import Footer from "../../components/footer";
import Fetch from "../../utils/fetch";
import moment from "moment";
import { ref } from "vue";
import { Icon, Col, Row, Tab, Tabs, Divider, Popup, Field, List } from "vant";
Vue.use(Icon)
  .use(Row)
  .use(Col)
  .use(Tab)
  .use(Tabs)
  .use(Divider)
  .use(Popup)
  .use(Field)
  .use(List);

export default {
  name: "events",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      activeTab: 0,
      sellMoviePopup: false,
      buyMoviePopup: false,
      sharesSell: "",
      sellPrice: "",
      buyPrice: "",
      favList: [],
      investList: [],
      c2cList: [],
      systemMessages: [],
      selectedMovie: {},
      purchaseShare: 0,
      investListPage: 1,
      favListPage: 1,
      c2cListPage: 1,
      finished: ref(false),
      loading: ref(false),
      userData: {},
      disableBuyBtn: false,
    };
  },
  mounted() {
    this.getMyInvestmentsList();
    this.getSystemMessages();
    this.getUserDetails();
  },
  methods: {
    callSellPopup(movie) {
      this.selectedMovie = movie;
      this.sellMoviePopup = true;
    },
    callBuyPopup(movie) {
      this.selectedMovie = movie;
      this.buyMoviePopup = true;
      this.disableBuyBtn = movie.uid == this.userData.uid;
    },
    onTabChange() {
      switch (this.activeTab) {
        case "MyInvestment":
          this.investListPage = 1;
          this.investList = [];
          this.finished = false;
          this.getMyInvestmentsList();
          break;
        case "MyCollection":
          this.favListPage = 1;
          this.favList = [];
          this.finished = false;
          this.getFavList();
          break;
        // case "C2CMarket":
        //   this.c2cListPage = 1;
        //   this.c2cList = [];
        //   this.finished = false;
        //   this.getC2CList();
        //   break;

        default:
          break;
      }
    },
    getSystemMessages() {
      Fetch("/movie/listUserSysMsg").then((r) => {
        this.systemMessages = r.data;
      });
    },
    getMyInvestmentsList() {
      Fetch("/movie/listUserInvests", {
        page: this.investListPage,
        num: 5,
      }).then((r) => {
        if (r.data.length === 0) {
          this.finished = true;
        } else {
          r.data.forEach((singleInvest) => {
            this.investList.push(singleInvest);
          });
        }
        this.loading = false;
      });
    },
    getFavList() {
      Fetch("/movie/listUserItems", {
        page: this.favListPage,
        num: 5,
      }).then((r) => {
        this.loading = false;
        if (r.data.length === 0) {
          this.finished = true;
        } else {
          r.data.forEach((singleFav) => {
            this.favList.push(singleFav);
          });
        }
      });
    },
    getC2CList() {
      Fetch("/movie/SellList", {
        page: this.c2cListPage,
        num: 5,
      }).then((r) => {
        this.loading = false;
        if (r.data.length === 0) this.finished = true;
        r.data.forEach((singleC2C) => {
          this.c2cList.push(singleC2C);
        });
      });
    },
    sellAMovie() {
      if (this.sellPrice === 0 || this.sharesSell === 0) return;

      Fetch("/movie/sell", {
        invest_id: this.selectedMovie.id,
        price: this.sellPrice,
        share: this.sharesSell,
      }).then((r) => {
        this.sellMoviePopup = false;

        //comment to hide C2C market
        // this.activeTab = "C2CMarket";
        // this.onTabChange();

        window.scrollTo(0, 0);
        this.$toast.success();
      });
    },
    cancelSell() {
      Fetch("/movie/cancelsell", {
        sell_id: this.selectedMovie.id,
      }).then((r) => {
        this.buyMoviePopup = false;
        this.c2cList = [];
        this.getC2CList();
      });
    },
    buyC2C() {
      Fetch("/movie/buy", {
        sell_id: this.selectedMovie.id,
        amount: this.buyPrice,
      }).then((r) => {
        this.buyMoviePopup = false;
        this.$toast({
          background: "#07c160",
          message: this.$t("events.success"),
        });
        this.c2cList = [];
        this.getC2CList();
      });
    },
    getDate(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
    calculateShare() {
      if (this.buyPrice && this.selectedMovie.price != 0) {
        this.purchaseShare = (
          (this.selectedMovie.share / this.selectedMovie.price) *
          this.buyPrice
        ).toFixed(8);
      } else {
        this.purchaseShare = 0;
      }
    },
    clearValues() {
      this.purchaseShare = 0;
      this.buyPrice = "";
      this.selectedMovie = {};
    },
    clearSellPopupValues() {
      (this.sharesSell = ""), (this.sellPrice = "");
    },
    onLoad() {
      this.loading = true;
      this.investListPage++;
      this.getMyInvestmentsList();
    },
    onLoadFav() {
      this.loading = true;
      this.favListPage++;
      this.getFavList();
    },
    onLoadC2C() {
      this.loading = true;
      this.c2cListPage++;
      this.getC2CList();
    },
    getUserDetails() {
      Fetch("/user/info").then((r) => {
        this.userData = r.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
  padding-bottom: 80px;
}

.eventListBg {
  background-image: linear-gradient(#f2d627, #e29218);
  margin: 10px;
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 5px;
}

.eventItem {
  display: flex;
  align-items: center;
  padding: 0px 10px 10px;
}
.eventTopic {
  color: #000000;
  font-size: 16px;
  font-weight: 700;
}
.eventDesc {
  color: #000000;
  font-size: 13px;
  margin-top: 4px;
}

.itemEvent {
  padding: 10px;
  border: 2px solid #ffffff;
  border-radius: 15px;
  margin: 20px 8px 0px;
  background: #ebebeb29;
}

.leftImage {
  object-fit: fill;
  width: 100%;
}

.moviesName {
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
}

.eventInfoItem {
  color: #ffffff;
  font-style: 12px;
  padding-left: 5px;
}

.sellBg {
  background: linear-gradient(90deg, #ff5c00 0%, rgba(244, 9, 9, 0.77) 121.03%);
  border-radius: 6px;
  margin-top: 10px;
}

.buttonText {
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  padding: 6px 0px;
}
// --------------- sell popup
.PopupBg {
  background: linear-gradient(180deg, #ffd700 0%, #ff9100 100%);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.24);
  border-radius: 12px;
}

.movieTopImage {
  object-fit: fill;
  width: 100%;
}

.labelTopic {
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
}

.labelValue {
  color: #ffffff;
  font-size: 15px;
}

.inputBg {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 7px;
  padding: 10px 5px;
  align-items: center;
  display: flex;
}

.inputValue {
  color: #ffffff;
  font-size: 15px;
  text-align: right;
  width: 100%;
}

.inputValue::-webkit-input-placeholder {
  color: #ece8d8;
}
.inputValue:-moz-placeholder {
  /* Upto Firefox 18, Deprecated in Firefox 19  */
  color: #ece8d8;
}
.inputValue::-moz-placeholder {
  /* Firefox 19+ */
  color: #ece8d8;
}
.inputValue:-ms-input-placeholder {
  color: #ece8d8;
}

.btnCancelBg {
  border-radius: 6px;
  margin-top: 10px;
  border: 1px solid #ffffff;
}

.btnConfirmBg {
  background: linear-gradient(90deg, #ff5c00 0%, rgba(244, 9, 9, 0.77) 121.03%);
  border-radius: 6px;
  margin-top: 10px;
}
</style>
<style>
#eventTabsTopic .van-tabs__line {
  border-bottom: unset;
  border-image: unset;
  background-color: transparent;
  bottom: 20px;
}

#eventTabsTopic .van-tabs__nav {
  background-color: transparent;
}

#eventTabsTopic .van-tab {
  color: #ffffff;
}

#eventTabsTopic .van-tab--active {
  color: #f6f600;
  font-size: 16px;
}
</style>
